import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit {
  @Input() mode: string = 'content';
  
  toolTip: string = '';
  
  constructor() { }

  ngOnInit() {}

}
